import { render, staticRenderFns } from "./FacilityStaffModal.vue?vue&type=template&id=d4b6873e&scoped=true&"
import script from "./FacilityStaffModal.vue?vue&type=script&lang=js&"
export * from "./FacilityStaffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b6873e",
  null
  
)

export default component.exports